import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Milestone, Activity } from 'toolbandi-ui-lib';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService, CrudService, MessageService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-milestone-edit',
	templateUrl: './milestone-edit.component.html',
	styleUrls: ['./milestone-edit.component.scss']
})
export class MilestoneEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	milestone: Milestone;
	@Input()
	activityid: number;
	activity: Activity;
	title: string;

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private milestoneService: CrudService<Milestone>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private activeModal: NgbActiveModal,
		private activityService: CrudService<Activity>
	) { }
	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.milestone = new Milestone();
				this.title = 'milestone-create';
				if (this.activityid) {
					this.milestone.activityid = this.activityid;
					this.findActivity(this.milestone.activityid);
				}
				this.loading = false;
			}
		});
	}

	load(id: number): void {
		this.loading = true;
		this.milestoneService.getEntity(Milestone, 'milestone', id).subscribe(obj => {
			this.milestone = obj;
			this.title = 'milestone-edit';
			this.loading = false;
			this.initItem();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.milestone'));
			this.milestone = undefined;
			this.loading = false;
		});

	}

	findActivity(aid: number): void {
		if (aid) {
			this.activityService.getEntity(Activity, 'activity', aid).subscribe((a: Activity) => {
				this.activity = a;
			});
		}
	}


	initItem(): void {
		this.findActivity(this.milestone.activityid);
	}


	dismiss(): void {
		this.activeModal.dismiss();
	}

	submit(): void {

		this.milestone.projectid = this.activity.projectid;

		if (!this.milestone.id) {
			this.milestoneService.createEntity(Milestone, 'milestone', this.milestone).subscribe(response => {
				this.milestone = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.milestone-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.milestone);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.milestoneService.saveEntity(Milestone, 'milestone', this.milestone).subscribe(response => {
				this.milestone = response;
				this.initItem();
				this.messageService.sendSuccess(
					this.translateService.instant('labels.milestone-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.milestone);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

}
